import gatewayService from '@/modules/common/services/gatewayService';
import logError from '@/utils/logError/logError';

const baseRoute = '/v3/license';

const getFeaturePackage = async (packageId) => {
    try {
        const result = await gatewayService.get(`${baseRoute}/features_packages/${packageId}`);
        return result?.data?.features_package ?? null;
    } catch (error) {
        logError('Error fetching feature package', error, { packageId });
        return null;
    }
};

const getAllFeaturePackages = async () => {
    try {
        const result = await gatewayService.get(`${baseRoute}/features_packages`);
        return result?.data?.data?.features_packages ?? [];
    } catch (error) {
        logError('Error fetching all feature packages', error);
        return [];
    }
};

const findFeaturePackageByName = (packages, packageName) => {
    if (!packages || !Array.isArray(packages)) {
        return null;
    }
    return packages.find((pkg) => pkg.name === packageName) || null;
};

export default {
    getFeaturePackage,
    getAllFeaturePackages,
    findFeaturePackageByName,
}; 
